/**
 * Capability for controlling access to the event editor.
 */
export const USE_ADVANCED_EDITOR = 'ee_advanced_event_editor';

/**
 * Capability for controlling access to the event editor bulk edit functionality.
 */
export const USE_EVENT_EDITOR_BULK_EDIT = 'ee_event_editor_bulk_edit';
